'use client';

import Error from 'next/error';
import { useRouter } from 'next/navigation';
import { useEffect } from 'react';

export default function NotFound() {
  const router = useRouter();
  useEffect(() => {
    // 延迟跳转（可选）
    const timer = setTimeout(() => {
      router.replace('/');
    }, 3000); // 3 秒后跳转首页
    return () => clearTimeout(timer);
  }, [router]);

  return <Error statusCode={404} />;
}
